module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "leave-active-class": "fadeOut"
    }
  }, [(_vm.visible) ? _c('article', {
    staticClass: "Hit-card box animated"
  }, [_c('div', {
    staticClass: "Hit-card_header media"
  }, [_c('router-link', {
    staticClass: "Hit-card_user-image media-left",
    attrs: {
      "to": _vm.plink,
      "tag": "div"
    }
  }, [_c('player-avatar', {
    attrs: {
      "player": _vm.player,
      "size": "48"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('router-link', {
    staticClass: "Hit-card_user-name",
    attrs: {
      "title": _vm.player.name,
      "to": _vm.plink,
      "tag": "strong"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.player.name) + "\n            ")]), _vm._v(" "), (_vm.showDate) ? [_vm._v("\n              -\n              "), _c('small', {
    staticClass: "Hit-card_date"
  }, [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.hit.created_at, "from", "now")) + "\n              ")])] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "Hit-card_user-meta",
    attrs: {
      "title": _vm.player.job
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.player.job))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "is-lastmeta",
    attrs: {
      "title": _vm.player.school.name
    }
  }, [_vm._v("\n              " + _vm._s(_vm.player.school.name) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "is-lastmeta"
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "is-lastmeta",
    attrs: {
      "title": _vm.player.league_promo
    }
  }, [_vm._v("\n              " + _vm._s(_vm.player.league_promo) + "\n            ")]), _vm._v(" "), (_vm.hit.challenge) ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), (_vm.hit.challenge) ? _vm._m(0) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "Hit-card_media"
  }, [(_vm.hit.type == 'IMAGE') ? _c('a', {
    class: {
      'lazy-init': _vm.hit.type == 'IMAGE'
    },
    attrs: {
      "href": _vm.hit.path,
      "title": _vm.$t('infotitle.zoom')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openImg(_vm.hit.path)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.hit.path),
      expression: "hit.path"
    }],
    attrs: {
      "alt": _vm.hit.title
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hit.type == 'CODE') ? _c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.hit.code_embed,
      "height": "390",
      "scrolling": "no",
      "frameborder": "0",
      "allowpaymentrequest": "",
      "allowtransparency": "true",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hit.type == 'VIDEO') ? _c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.hit.video_embed,
      "height": "390",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hit.type == 'LINK') ? _c('a', {
    staticClass: "title is-3 is-size-5-touch",
    attrs: {
      "href": _vm.hit.path,
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.link_path) + "\n      ")]) : _vm._e()]), _vm._v(" "), (!_vm.isPublic && _vm.hit.player_id == _vm.user.player.id) ? _c('div', {
    staticClass: "Hit-card_userbar"
  }, [_c('button', {
    staticClass: "button is-text is-text-danger",
    on: {
      "click": function($event) {
        _vm.editHit(_vm.hit)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.edit')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-text is-text-danger",
    on: {
      "click": function($event) {
        _vm.deleteHit(_vm.hit)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.delete')) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Hit-card_content content"
  }, [_c('h2', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.hit.title))]), _vm._v(" "), _c('p', {
    staticClass: "is-description",
    domProps: {
      "innerHTML": _vm._s(_vm.html_description)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tags",
    attrs: {
      "title": _vm.$t('infotitle.hit_tags')
    }
  }, _vm._l((_vm.hit.tags), function(tag) {
    return _c('span', {
      key: tag.id,
      staticClass: "tag is-medium is-size-7-touch",
      class: {
        'is-used': tag.user_liked, 'is-unused': !tag.user_liked
      },
      on: {
        "click": function($event) {
          _vm.likeTag(_vm.hit, tag)
        }
      }
    }, [_c('strong', [_vm._v("+ " + _vm._s(tag.name) + " ")]), _vm._v(" (" + _vm._s(tag.pivot.likes_count) + ")\n        ")])
  }))]), _vm._v(" "), (!_vm.isPublic) ? [_c('div', {
    staticClass: "media comment-form"
  }, [_c('form', {
    staticClass: "media-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addComment(_vm.hit)
      }
    }
  }, [_c('p', {
    staticClass: "control",
    class: {
      'is-loading': _vm.loading
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.new_comment),
      expression: "new_comment",
      modifiers: {
        "trim": true
      }
    }],
    ref: "comment",
    staticClass: "textarea",
    class: {
      'is-open-small': _vm.new_comment
    },
    attrs: {
      "placeholder": _vm.$t('fields.add_comment')
    },
    domProps: {
      "value": (_vm.new_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_comment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "comment-form_actions"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.new_comment),
      expression: "new_comment"
    }],
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('buttons.send')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Hit-card_actions media-right"
  }, [_c('a', {
    staticClass: "btn-like",
    class: {
      'has-liked': _vm.hit.user_liked
    },
    attrs: {
      "title": _vm.$t('infotitle.like')
    },
    on: {
      "click": function($event) {
        _vm.like(_vm.hit)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-like-counter",
    on: {
      "click": function($event) {
        _vm.showLikes(_vm.hit)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.hit.likes_count) + "\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-comment",
    class: {
      'has-commented': _vm.hit.user_commented
    },
    attrs: {
      "title": _vm.$t('infotitle.comment')
    },
    on: {
      "click": function($event) {
        _vm.$refs.comment.focus()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-comment-counter",
    on: {
      "click": function($event) {
        _vm.$refs.comment.focus()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.hit.comments_count) + "\n          ")])])]), _vm._v(" "), (_vm.comments.total > _vm.comments.data.length) ? _c('p', {
    staticClass: "Hit-card_more-comments"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.loadMoreComments(_vm.hit)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('buttons.see_comments')) + "\n        ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.comments.data), function(comment) {
    return _c('comment', {
      key: comment.id,
      attrs: {
        "id": 'comment-' + comment.id,
        "comment": comment
      },
      on: {
        "deleted": _vm.onCommentDeleted
      }
    })
  })] : _vm._e(), _vm._v(" "), (_vm.bigimg) ? _c('div', {
    staticClass: "zoom",
    class: {
      'is-zoomed': _vm.zoomimg
    },
    attrs: {
      "title": _vm.$t('infotitle.zoom')
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bigimg
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.zoomimg = !_vm.zoomimg
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "delete is-large",
    on: {
      "click": function($event) {
        _vm.closeImg()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('modal-base', {
    staticClass: "Hit-card_likes",
    attrs: {
      "open": _vm.likes_open
    },
    on: {
      "close": function($event) {
        _vm.likes_open = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-content box content"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.likes_loading),
      expression: "likes_loading"
    }]
  }, [_vm._v(_vm._s(_vm.$t('loading')))]), _vm._v(" "), (!_vm.likes_loading && !_vm.likes.length) ? _c('p', [_vm._v(_vm._s(_vm.$t('empty')))]) : _vm._e(), _vm._v(" "), (!_vm.likes_loading) ? _vm._l((_vm.likes), function(like) {
    return _c('router-link', {
      key: like.id,
      staticClass: "Hit-card_likes_item",
      attrs: {
        "to": {
          name: 'player',
          params: {
            id: like.user.player.slug
          }
        },
        "tag": "div"
      },
      on: {
        "click": function($event) {
          _vm.likes_open = false
        }
      }
    }, [_c('player-avatar', {
      attrs: {
        "player": like.user.player
      }
    }), _vm._v("\n            " + _vm._s(like.user.player.name) + "\n          ")], 1)
  }) : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.likes_open = false
      }
    }
  })])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "is-challenge-link",
    attrs: {
      "tag": "span",
      "to": {
        name: 'challenge',
        params: {
          id: _vm.hit.challenge.slug
        }
      },
      "title": _vm.hit.challenge.name
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('hit.posted_in_challenge', {
    name: _vm.hit.challenge.name
  })) + "\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-603e02d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hit/HitCard.vue
// module id = 360
// module chunks = 9